var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FA_TIMES } from '../../../const/iconProps';
import { statusColors } from '../../../defaultTheme';
import { IconWrapper, MessageBody, MessageCard, MessageCloseButton } from './subcomponents';
const MessageBox = forwardRef((_a, ref) => {
    var { icon, children, className, closeIconColor, closeHandler, type = 'info', closeButtonAriaLabel = 'Dismiss Message' } = _a, props = __rest(_a, ["icon", "children", "className", "closeIconColor", "closeHandler", "type", "closeButtonAriaLabel"]);
    return (React.createElement(MessageCard, Object.assign({ type: type, className: className, ref: ref }, props),
        icon && React.createElement(IconWrapper, { type: type }, icon),
        closeHandler && (React.createElement(MessageCloseButton, { buttonType: "text", onClick: closeHandler, ariaLabel: closeButtonAriaLabel },
            React.createElement(FontAwesomeIcon, { icon: FA_TIMES, type: type, color: closeIconColor || statusColors[type].icon, size: "sm" }))),
        React.createElement(MessageBody, { type: type }, children)));
});
export default MessageBox;
